import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useNavigate, useParams } from 'react-router'
import {
  AnimatedCheckMark,
  getTaskTitle,
  LinkExternal,
  MapWithMarker,
  TopBar,
  AppLayout,
  useGetSampleByIdQuery,
  useGetTaskByIdQuery,
  Mtds,
  NoPosFoundError,
  geometryToLongitudeLatitude
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'

export const SampleRegistrationCompletedScreen = () => {
  const { sampleId } = useParams()
  const navigate = useNavigate()
  const {
    data: sample,
    isPending: isPendingSample,
    isError: isErrorSample
  } = useGetSampleByIdQuery(sampleId)
  const {
    data: task,
    isPending: isPendingTask,
    isError: isErrorTask
  } = useGetTaskByIdQuery(sample?.taskId)
  const isPending = isPendingSample || isPendingTask
  const isError = isErrorSample || isErrorTask
  const lonLat = sample
    ? geometryToLongitudeLatitude(sample.geometry)
    : undefined

  useEffect(() => {
    if ('vibrate' in navigator) {
      const pattern = [200, 100, 200, 100, 200, 100, 200]
      navigator.vibrate(pattern)
    }
  }, [])

  const breadcrumbItems = [
    {
      label: 'Prøver',
      to: '/samples'
    },
    {
      label: '#' + sampleId,
      to: `/samples/${sampleId}`
    },
    {
      label: 'Fullført registrering'
    }
  ]

  let locationDisplay: ReactNode = null
  if (task?.locationRequired) {
    if (lonLat) {
      locationDisplay = (
        <MapWithMarker
          latitude={lonLat.latitude}
          longitude={lonLat.longitude}
        />
      )
    } else {
      locationDisplay = <NoPosFoundError />
    }
  }

  return (
    <AppLayout
      isLoading={isPending}
      isError={isError}
      topBar={<TopBar logo={<AppLogo />} breadcrumbItems={breadcrumbItems} />}
      contentLayout='none'
    >
      <Mtds.Grid data-align='center' data-gap={12} className='h-full'>
        <Mtds.Grid data-justify='center' data-gap={12} data-color='success'>
          <AnimatedCheckMark />
          <Mtds.Prose data-justify='center'>
            <Mtds.Heading as='h1' data-size='lg' data-justify='center'>
              Prøve registrert
            </Mtds.Heading>
            <p>
              Prøve{' '}
              {
                <LinkExternal
                  to={'/samples/' + sample?.id}
                  text={sample?.id ?? '-'}
                  data-cy='sample-detail-link'
                ></LinkExternal>
              }{' '}
              er nå registrert på oppgave{' '}
              {
                <LinkExternal
                  to={'/tasks/' + task?.id}
                  text={getTaskTitle(task)}
                  data-cy='task-detail-link'
                ></LinkExternal>
              }
            </p>
          </Mtds.Prose>
        </Mtds.Grid>
        {locationDisplay}
        <Mtds.Button
          data-arrow='left'
          data-variant={'primary'}
          onClick={() => navigate('/tasks/' + task?.id)}
          data-cy='back-to-task-button'
        >
          Tilbake til oppgave
        </Mtds.Button>
      </Mtds.Grid>
    </AppLayout>
  )
}
